export default defineNuxtRouteMiddleware(async (to) => {

  if (!process.client) return

  const adminStore = useAdminStore()

  // If already authenticated with user data, allow access
  if (adminStore.isAuthenticated && adminStore.user) {
    return
  }

  // Wait for initialization if it's in progress
  if (adminStore.isInitializing) {
    // Wait for initialization to complete
    await new Promise<void>((resolve) => {
      const checkInit = setInterval(() => {
        if (!adminStore.isInitializing) {
          clearInterval(checkInit)
          resolve()
        }
      }, 50)
      // Timeout after 5 seconds
      setTimeout(() => {
        clearInterval(checkInit)
        resolve()
      }, 5000)
    })

    // After waiting, check if now authenticated
    if (adminStore.isAuthenticated && adminStore.user) {
      return
    }
  }

  // Try to fetch user from session (HttpOnly cookie automatically sent)
  if (!adminStore.user) {
    try {
      await adminStore.fetchUser()

      // Check if user is authenticated and has admin role
      if (adminStore.isAuthenticated && (adminStore.isAdmin || adminStore.isSuperAdmin)) {
        return
      }
    } catch {
      // Expected for guest sessions; redirect below handles unauthenticated state.
    }
  }

  // Redirect to login if not authenticated
  return navigateTo('/admin/login', { 
    replace: true,
    external: false
  })
})